import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ConfigurationManagerService } from 'src/app/core/services/configuration-manager/configuration-manager.service';
import { transformArrayToObject } from 'src/app/shared/components';

@Injectable({
  providedIn: 'root'
})
export class LocalizationService {
  private readonly translateService = inject(TranslateService);
  private readonly configurationManager = inject(ConfigurationManagerService);

  public translate(headerIdentifier: string): string {
    if (!headerIdentifier || typeof headerIdentifier !== 'string') {
      return headerIdentifier || '';
    }

    // Caso impostazioni (-s)
    if (headerIdentifier.substring(0, 2) === '-s') {
      const settingKey = headerIdentifier.split(" ", 2)[1];
      return this.configurationManager.getSetting(settingKey as any) || '';
    }

    // Caso parametri (|)
    if (headerIdentifier.includes('|')) {
      const parts = headerIdentifier.split('|');
      const key = parts[0];
      const interpolateParams = transformArrayToObject(parts[1].split(','));
      return this.translateService.instant(key, interpolateParams);
    }

    // Caso traduzione semplice
    return this.translateService.instant(headerIdentifier);
  }
}